import React from "react"

import dayGridPlugin from "@fullcalendar/daygrid"
import listPlugin from "@fullcalendar/list"
import FullCalendar from "@fullcalendar/react"

import useIsMobile from "hooks/useIsMobile"

type SessionCalendarProps = {
  eventSource: string
}

const SessionCalendar: React.FC<SessionCalendarProps> = ({ eventSource }) => {
  const isMobile = useIsMobile()

  return (
    <FullCalendar
      plugins={[dayGridPlugin, listPlugin]}
      initialView={isMobile ? "listMonth" : "dayGridMonth"}
      events={eventSource}
      eventColor="#5596C1"
      eventDisplay="block"
      timeZone="local"
      headerToolbar={{
        left: "title",
        center: isMobile ? "" : "listMonth,dayGridMonth",
        right: "today prev,next",
      }}
      buttonText={{ today: "Today", month: "Calendar", list: "List" }}
      eventTimeFormat={{
        hour: "numeric",
        minute: "2-digit",
        meridiem: "short",
        omitZeroMinute: true,
      }}
    />
  )
}

export default SessionCalendar
